import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HttpHeadersService {

  constructor(private httpclient: HttpClient) { }

  preLoginHttpAuthorizationHeader() {
    let headers = new HttpHeaders();
    const time = new Date();
    const timestamp = Math.floor(time.getTime() / 1000);
    const timestampnonce = timestamp + Math.random();
    const OAUTH_KEY = 'LFCWSAPICONSUMERKEY';
    const OAUTH_SIGNATURE = 'TEZDV1NBUElDT05TVU1FUlNFQ1JFVA==';
    const header = 'OAuth oauth_consumer_key="' + OAUTH_KEY + '", oauth_nonce="'+timestampnonce+'",oauth_timestamp="'+timestamp+'",oauth_signature="'+OAUTH_SIGNATURE+'"';
    headers = headers.set('Authorization', header);
    headers = headers.set('Content-Type', 'application/json');
    return headers;
  }


  bearerHttpAuthorizationHeader() {
    let headers = new HttpHeaders();
    var vtToken=localStorage.getItem("vtTokenKey");
    if(sessionStorage.getItem("vtTokenKey")!=null)
       vtToken=sessionStorage.getItem("vtTokenKey");
   
    headers= headers.set('Authorization', "Bearer "+vtToken); 
    headers=headers.set('Content-Type', 'application/json');
    return headers;
  }

  bearerHttpAuthorizationHeaderWithoutContentType() {
    let headers = new HttpHeaders();
    var vtToken=localStorage.getItem("vtTokenKey");
    if(sessionStorage.getItem("vtTokenKey")!=null)
       vtToken=sessionStorage.getItem("vtTokenKey");
   
    headers= headers.set('Authorization', "Bearer "+vtToken);
    return headers;
  }

  bearerIAPHttpAuthorizationHeader() {
    let headers = new HttpHeaders();
    let iapToken;
    if(localStorage.getItem("gaeapptoken")!=null)
      iapToken=localStorage.getItem("gaeapptoken");

    headers= headers.set('Authorization', "Bearer "+iapToken); 
    headers=headers.set('Content-Type', 'application/json');
    return headers;
  }

  bearerGcpHttpAuthorizationHeader() {
    let headers = new HttpHeaders();
    let gcpToken;
    if(localStorage.getItem("gcpToken")!=null)
      gcpToken=localStorage.getItem("gcpToken");

    headers = headers.set('Authorization', "Bearer "+gcpToken);
    headers = headers.append('X-Halo-Auth', gcpToken??'');
    headers = headers.append('Content-Type', 'application/json');
    return headers;
  }

  bearerGcpHttpAuthorizationHeaderWithoutContentType() {
    let headers = new HttpHeaders();
    let gcpToken;
    if(localStorage.getItem("gcpToken")!=null)
      gcpToken=localStorage.getItem("gcpToken");

    headers = headers.set('Authorization', "Bearer "+gcpToken);
    headers = headers.append('X-Halo-Auth', gcpToken??'');
    return headers;
  }
}
